export const activePage = 0;
export const numberOfItemsPerPage = 10;
export const maxNumberOfItemsPerPage = 100;
export const uploadFileMaxSize = 10000000;
export const rowsPerPageOptions = [10, 20, 50, 100];
export const notificationTypeSuccess = 'success';
export const notificationTypeInfo = 'info';
export const notificationTypeWarning = 'warning';
export const notificationTypeError = 'error';
export const allowedFileFormats = '.pdf, .docx, application/pdf';
export const locale = {
  default: 'sr',
  lat: 'lat',
};

// TEST/RAZVOJ
export const sessionStoragePRO = process.env.REACT_APP_SESSION_PRO_URL;

export const sessionStorageSuper =
  'oidc.user:https://prijava.test.eid.gov.rs/oauth2/oidcdiscovery/.well-known/openid-configuration:9b_4JRjA0zamG9YuWcds3zJLkPAa';

export const uploadFileDecisionTypeAllowedTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const uploadFileDecisionAllowedTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const uploadFileRequestForSignetApprovalAllowedTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const userRoles = {
  SUPER_ADMIN: { text: 'superAdmin', value: 1 },
  ADMIN_EU: { text: 'admineu', value: 2 },
  ADMIN_MDULS: { text: 'adminmduls', value: 3 },
  MDULS: { text: 'olMduls', value: 4 },
  AUTHORIZED_PERSON: { text: 'olOrgana', value: 5 },
  INSPECTOR: { text: 'inspektorat', value: 6 },
};

export const languageAndScript = {
  CYRILLIC: 'Српски језик, ћирилично писмо',
  CYRILLIC_AND_LATIN: 'Српски језик, ћирилично и латинично писмо',
};

export const decisionTypeTypes = {
  DIGITAL_SIGNET: {
    text: 'Електронски формат',
    value: 'DIGITAL_SIGNET',
  },
  IMPRINT_SIGNET: {
    text: 'Формат отиска',
    value: 'IMPRINT_SIGNET',
  },
  DIGITAL_SIGNET_AP: {
    text: 'Електронски формат за АП',
    value: 'DIGITAL_SIGNET_AP',
  },
};

export const autonomousProvinces = {
  VOJVODINA: {
    text: 'Војводина',
    value: 'VOJVODINA',
    valueForFilter: '0',
  },
  KOSOVO_I_METOHIJA: {
    text: 'Косово и Метохија',
    value: 'KOSOVO_I_METOHIJA',
    valueForFilter: '1',
  },
};

export const requestForSignetApprovalStatus = [
  {
    text: 'У припреми',
    value: 2,
    constant: 'IN_PREPARATION',
  },
  {
    text: 'Поднет',
    value: 1,
    constant: 'SUBMIT',
  },
  {
    text: 'Повучен',
    value: 3,
    constant: 'WITHDRAWN',
  },
  {
    text: 'У обради',
    value: 4,
    constant: 'IN_PROCESSING',
  },
  {
    text: 'Потребна допуна',
    value: 5,
    constant: 'REQUIRED_COMPLEMENTATION',
  },
  {
    text: 'Допуњен',
    value: 0,
    constant: 'COMPLEMENTED',
  },
  {
    text: 'Одобрен',
    value: 6,
    constant: 'ACCEPTED',
  },
  {
    text: 'Одбачен',
    value: 7,
    constant: 'REJECTED',
  },
  {
    text: 'Одбијен',
    value: 8,
    constant: 'REFUSE',
  },
  {
    text: 'Сторниран',
    value: 9,
    constant: 'CANCELED',
  },
  {
    text: 'Завршен',
    value: 10,
    constant: 'COMPLETED',
  },
  {
    text: 'Архивиран',
    value: 11,
    constant: 'ARCHIVED',
  },
];

export const requestForSignetstatusStatuses = {
  LOST: {
    text: 'Изгубљен',
    value: 'LOST',
  },
  TERMINATED: {
    text: 'Престанак важења',
    value: 'TERMINATED',
  },
  COMPROMISED: {
    text: 'Компромитован',
    value: 'COMPROMISED',
  },
  NOT_CONSENTED: {
    text: 'Није добијена сагласност',
    value: 'NOT_CONSENTED',
  },
};

export const actionsRequestForSignetApproval = {
  REQUEST_FOR_SIGNET_APPROVAL_UPDATE: 'REQUEST_FOR_SIGNET_APPROVAL_UPDATE',
  COMPLEMENT_REQUEST_APPROVAL_CREATE: 'COMPLEMENT_REQUEST_APPROVAL_CREATE',
  ADD_PROCESSOR: 'ADD_PROCESSOR',
  ACCEPT_REQUEST_FOR_SIGNET_APPROVAL: 'ACCEPT_REQUEST_FOR_SIGNET_APPROVAL',
  ADD_REFERENCE_NUMBER: 'ADD_REFERENCE_NUMBER',
  DECISION_ATTACHMENT_CREATE: 'DECISION_ATTACHMENT_CREATE',
  SIGN_DECISION: 'SIGN_DECISION',
  VIEW_DECISION_ACTIONS: 'VIEW_DECISION_ACTIONS',
  SENT_DECISION: 'SENT_DECISION',
  DOWNLOAD_DECISION: 'DOWNLOAD_DECISION',
  CONFIRM_DECISION_DELIVERY: 'CONFIRM_DECISION_DELIVERY',
  DOWNLOAD_REQUEST: 'DOWNLOAD_REQUEST',
  REQUEST_FOR_SIGNET_APPROVAL_CREATE: 'REQUEST_FOR_SIGNET_APPROVAL_CREATE',
  COMPLEMENT_REQUEST_CONTENT: 'COMPLEMENT_REQUEST_CONTENT',
  REQUEST_FOR_SIGNET_APPROVAL_STATUS_REVERT:
    'REQUEST_FOR_SIGNET_APPROVAL_STATUS_REVERT',
  DECISION_STATUS_REVERT: 'DECISION_STATUS_REVERT',
  UPDATE_REQUEST_CLIENT: 'UPDATE_REQUEST_CLIENT',
};

export const actionsSignet = {
  SUBMISSION_DATA_SIGNET_CREATE: 'SUBMISSION_DATA_SIGNET_CREATE',
  SUBMISSION_DATA_SIGNET_UPDATE: 'SUBMISSION_DATA_SIGNET_UPDATE',
  COMPLEMENT_SIGNET_CREATE: 'COMPLEMENT_SIGNET_CREATE',
  ACCEPT_SUBMISSION_DATA_SIGNET: 'ACCEPT_SUBMISSION_DATA_SIGNET',
  REQUEST_FOR_SIGNET_STATUS_CREATE: 'REQUEST_FOR_SIGNET_STATUS_CREATE',
  VALIDATE_REQUEST_FOR_SIGNET_STATUS: 'VALIDATE_REQUEST_FOR_SIGNET_STATUS',
  DOWNLOAD_EXAMPLE_SIGNET: 'DOWNLOAD_EXAMPLE_SIGNET',
};

export const actionsDecision = {
  DOWNLOAD_DECISION: 'DOWNLOAD_DECISION',
};

export const controllerPath = {
  REQUEST_FOR_SIGNET_APPROVAL: 'requestForSignetApproval',
  DECISION: 'decision',
  SIGNET: 'signet',
  SIGNET_EXAMPLE: 'signetExample',
};

export const decisionStatus = [
  {
    text: 'У изради',
    value: 1,
    constant: 'IN_PREPARATION',
  },
  {
    text: 'Потписано',
    value: 2,
    constant: 'VERIFIED',
  },
  {
    text: 'Послато',
    value: 3,
    constant: 'SENT',
  },
  {
    text: 'Поново послато',
    value: 4,
    constant: 'SENT_AGAIN',
  },
  {
    text: 'Прихваћена достава',
    value: 5,
    constant: 'DELIVERY_ACCEPTED',
  },
  {
    text: 'Одбијено',
    value: 6,
    constant: 'REJECTED',
  },
  {
    text: 'Достављено без преузимања',
    value: 7,
    constant: 'DELIVERED_WITHOUT_TAKEOVER',
  },
  {
    text: 'Достављено',
    value: 0,
    constant: 'DELIVERED',
  },
  {
    text: 'Правоснажно',
    value: 8,
    constant: 'FINAL',
  },
  {
    text: 'Сторнирано',
    value: 9,
    constant: 'SUSPENDED',
  },
];

export const signetStates = {
  IN_USE: {
    text: 'IN_USE',
    value: 0,
  },
  OUT_OF_USE: {
    text: 'OUT_OF_USE',
    value: 2,
    color: 'warning-red-color',
  },
  READY_TO_USE: {
    text: 'READY_TO_USE',
    value: 1,
    color: 'info-blue-color',
  },
};

//TODO dopuniti po potrebi
export const requestForSignetApprovalStatuses = {
  COMPLEMENTED: {
    text: 'Допуњен',
    name: 'COMPLEMENTED',
    color: 'info-blue-color',
  },
  REQUIRED_COMPLEMENTATION: {
    text: 'Потребна допуна',
    name: 'REQUIRED_COMPLEMENTATION',
    color: 'warning-red-color',
  },
  ACCEPTED: {
    text: 'Одобрен',
    name: 'ACCEPTED',
    color: 'valid-green-color',
  },
  SUBMIT: {
    text: 'Послат',
    name: 'SUBMIT',
  },
  IN_PREPARATION: {
    text: 'У припреми',
    name: 'IN_PREPARATION',
  },
  CANCELED: {
    text: 'Сторниран',
    name: 'CANCELED',
  },
  IN_PROCESSING: {
    text: 'У обради',
    name: 'IN_PROCESSING',
  },
};

export const signetStatuses = {
  COMPLEMENTED: {
    text: 'Допуњен',
    name: 'COMPLEMENTED',
    value: 0,
    color: 'info-blue-color',
  },
  APPROVED: {
    text: 'Одобрен',
    name: 'APPROVED',
    value: 2,
    color: 'valid-green-color',
  },
  REJECTED: {
    text: 'Одбијен',
    name: 'REJECTED',
    value: 3,
  },
  COMPLEMENT_REQUIRED: {
    text: 'Потребна допуна',
    name: 'COMPLEMENT_REQUIRED',
    value: 4,
    color: 'warning-red-color',
  },
  DELIVERED: {
    text: 'Достављен',
    name: 'DELIVERED',
    value: 1,
    color: 'info-blue-color',
  },
  FINISHED: {
    text: 'Завршен',
    name: 'FINISHED',
    value: 9,
    color: 'valid-green-color',
  },
  LOST: {
    text: 'Изгубљен',
    name: 'LOST',
    value: 5,
  },
  TERMINATED: {
    text: 'Престао да важи',
    name: 'TERMINATED',
    value: 6,
  },
  COMPROMISED: {
    text: 'Компромитован',
    name: 'COMPROMISED',
    value: 7,
  },
  NOT_CONSENTED: {
    text: 'Није добијена сагласност',
    name: 'NOT_CONSENTED',
    value: 8,
  },
  REVOKED: {
    text: 'Опозван',
    name: 'REVOKED',
    value: 10,
  },
  CANCELED: {
    text: 'Сторниран',
    name: 'CANCELED',
    value: 11,
  },
};

export const signetStatesАrray = [
  {
    text: 'У употреби',
    value: 0,
    constant: 'IN_USE',
  },
  {
    text: 'Спреман за употребу',
    value: 1,
    constant: 'READY_TO_USE',
  },
  {
    text: 'Ван употребе',
    value: 2,
    constant: 'OUT_OF_USE',
  },
];

export const signetStatusArray = [
  {
    text: 'Допуњен',
    value: 0,
    constant: 'COMPLEMENTED',
  },
  {
    text: 'Достављен',
    value: 1,
    constant: 'DELIVERED',
  },
  {
    text: 'Одобрен',
    value: 2,
    constant: 'APPROVED',
  },
  {
    text: 'Одбијен',
    value: 3,
    constant: 'REJECTED',
  },
  {
    text: 'Потребна допуна',
    value: 4,
    constant: 'COMPLEMENT_REQUIRED',
  },
  {
    text: 'Завршен',
    value: 9,
    constant: 'FINISHED',
  },
  {
    text: 'Опозван',
    value: 10,
    constant: 'REVOKED',
  },
  {
    text: 'Изгубљен',
    value: 5,
    constant: 'LOST',
  },
  {
    text: 'Престао да важи',
    value: 6,
    constant: 'TERMINATED',
  },
  {
    text: 'Компромитован',
    value: 7,
    constant: 'COMPROMISED',
  },
  {
    text: 'Није добијена сагласност',
    value: 8,
    constant: 'NOT_CONSENTED',
  },
  {
    text: 'Сторниран',
    value: 11,
    constant: 'CANCELED',
  },
];

//TODO Dopuniti po potrebi
export const decisionStatuses = {
  VERIFIED: {
    text: 'VERIFIED',
  },
  SENT: {
    text: 'SENT',
  },
  DELIVERED: {
    text: 'DELIVERED',
  },
  IN_PREPARATION: {
    text: 'IN_PREPARATION',
  },
};

export const mdulsAdminEmail = 'epecat.mduls@mduls.gov.rs';
